import { ButtonLink, Card, Flex, Text } from '@backstage/ui';
import { RiExternalLinkLine } from '@remixicon/react';
import type { ReactNode } from 'react';
import type { Codespace } from '../../types';
import { CodespaceStatus } from '../CodespaceStatus/CodespaceStatus';
import { CodespaceField } from './CodespaceField';
import styles from './CodespaceCard.module.css';

export const CodespaceCard = ({
  codespace,
  showRepository = false,
  renderTransparent = false,
}: {
  codespace: Codespace;
  showRepository?: boolean;
  renderTransparent?: boolean;
}) => {
  const fields: { label: string; value: ReactNode }[] = [
    { label: 'Last used', value: codespace.lastUsedRelative },
    { label: 'Status', value: <CodespaceStatus codespace={codespace} /> },
    ...(showRepository ? [{ label: 'Repository', value: codespace.repoName }] : []),
    { label: 'Branch', value: codespace.branch },
  ];

  const content = (
    <Flex direction="column" gap="3">
      <Flex direction="row" justify="between" align="center" gap="2">
        <Text variant="title-x-small">{codespace.name}</Text>
        <ButtonLink
          iconEnd={<RiExternalLinkLine />}
          href={codespace.webUrl}
          variant="secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open
        </ButtonLink>
      </Flex>
      <Flex direction="row" gap="5" align="start">
        {fields.map(({ label, value }) => (
          <CodespaceField key={label} label={label} value={value} />
        ))}
      </Flex>
    </Flex>
  );

  if (renderTransparent) {
    return <div className={`${styles.codespaceCard} ${styles.renderTransparent}`}>{content}</div>;
  }

  return <Card className={styles.codespaceCard}>{content}</Card>;
};
